var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowToRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96776 0.290325L9.03432 0.21967C9.3227 -0.0506931 9.77649 -0.0714902 10.0903 0.157278L10.1657 0.21967L15.7657 5.46967L15.7988 5.50264L15.8429 5.55352L15.9003 5.63695L15.943 5.7215L15.9713 5.80051L15.9945 5.91143L16 6L15.9978 6.05643L15.9838 6.15054L15.9602 6.23411L15.9251 6.31742L15.8832 6.39053L15.8242 6.46909L15.7657 6.53033L10.1657 11.7803C9.85327 12.0732 9.34673 12.0732 9.03432 11.7803C8.74593 11.51 8.72374 11.0845 8.96776 10.7903L9.03432 10.7197L13.2672 6.75H0.8C0.358172 6.75 0 6.41421 0 6C0 5.58579 0.358172 5.25 0.8 5.25H13.2688L9.03432 1.28033C8.74593 1.00997 8.72374 0.584544 8.96776 0.290325L9.03432 0.21967L8.96776 0.290325Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToRight);
export default __webpack_public_path__ + "static/media/ArrowToRight.f5568a50.svg";
export { ForwardRef as ReactComponent };